import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, FlameIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const checklist = ['Sientes que trabajas duro pero el dinero nunca alcanza', 'Saboteas tus propias oportunidades sin entender por qué', 'Quieres un sistema completo, no solo tips genéricos', 'Estás listo para trabajar tu mente tanto como trabajas tus números', 'Tienes fe y quieres un sistema completamente alineado con ella'];
const timeline = [{
  time: 'Día 1',
  result: 'Identificas tu saboteador principal por primera vez en tu vida'
}, {
  time: 'Semana 1',
  result: 'Primer protocolo de reprogramación mental instalado y funcionando'
}, {
  time: 'Mes 1',
  result: 'Estructura 70/30 activa con tu primer ahorro o inversión real'
}, {
  time: 'Mes 3',
  result: 'Ingresos notablemente superiores al día que empezaste'
}, {
  time: 'Año 1',
  result: 'Una vida financiera que hoy parece imposible'
}];
export function FinalCTASection() {
  return <section className="py-14 md:py-16 px-4 md:px-8 bg-navy-900 relative" data-id="element-81">
      <div className="max-w-5xl mx-auto" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-83">
          <h3 className="text-4xl md:text-6xl font-bold mb-8" data-id="element-84">
            Deja De Sabotear Tu Abundancia.
          </h3>

          <div className="text-lg md:text-xl text-gray-300 space-y-4 max-w-3xl mx-auto" data-id="element-85">
            <p data-id="element-86">No el próximo lunes. No cuando mejore la situación.</p>
            <p data-id="element-87">No cuando te sientas más listo.</p>
            <p className="text-white font-bold text-2xl" data-id="element-88">Hoy.</p>
            <p data-id="element-89">
              Cada mes que postergas este cambio, tu mente te está costando
              entre <strong className="text-red-400" data-id="element-90">$1,000 y $5,000</strong> en
              oportunidades que no ves, precios que no cobras y decisiones que
              el programa viejo toma por ti.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20" data-id="element-91">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-800 rounded-2xl p-8 border border-gray-700" data-id="element-92">
            <h4 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-93">
              <CheckCircleIcon className="text-gold" data-id="element-94" /> Esto Es Para Ti Si:
            </h4>
            <ul className="space-y-4" data-id="element-95">
              {checklist.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-96">
                  <div className="mt-1 w-5 h-5 rounded border border-gold flex items-center justify-center flex-shrink-0 bg-gold/20" data-id="element-97">
                    <div className="w-2.5 h-2.5 bg-gold rounded-sm" data-id="element-98"></div>
                  </div>
                  <span data-id="element-99">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-800 rounded-2xl p-8 border border-amber-500/30 box-glow" data-id="element-100">
            <h4 className="text-2xl font-bold text-amber-500 mb-6 flex items-center gap-3" data-id="element-101">
              <FlameIcon data-id="element-102" /> Lo Que Pasa Cuando Actúas Hoy:
            </h4>
            <div className="space-y-4" data-id="element-103">
              {timeline.map((item, i) => <div key={i} className="flex flex-col sm:flex-row gap-2 sm:gap-4 pb-4 border-b border-gray-700 last:border-0 last:pb-0" data-id="element-104">
                  <div className="sm:w-1/3 font-bold text-white" data-id="element-105">
                    {item.time}
                  </div>
                  <div className="sm:w-2/3 text-gray-400 text-sm sm:text-base" data-id="element-106">
                    {item.result}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} id="cta-final" className="text-center bg-gradient-to-t from-navy-800 to-navy-900 border border-gold/50 rounded-3xl p-8 md:p-16 shadow-[0_0_50px_rgba(212,160,23,0.2)]" data-id="element-107">
          <div className="flex flex-col items-center gap-3 mb-8" data-id="element-108">
            <span className="inline-block bg-red-500/20 text-red-400 text-sm md:text-base font-bold px-5 py-2 rounded-full border border-red-500/30 tracking-wide" data-id="element-109">
              🔥 83% DE DESCUENTO
            </span>
            <div className="flex items-center justify-center gap-4" data-id="element-110">
              <span className="text-2xl md:text-4xl text-red-500 line-through font-bold opacity-80" data-id="element-111">
                $37 USD
              </span>
              <span className="text-4xl md:text-6xl text-gold font-bold" data-id="element-112">
                Solo $6.36 USD
              </span>
            </div>
          </div>

          <CTAButton href="https://vitalyforms.com/cart/48329378398428:1" className="w-full md:w-auto md:px-12 md:py-6 text-lg md:text-xl mb-8" data-id="element-113">
            SÍ, QUIERO MI PLAN DE ABUNDANCIA AHORA
          </CTAButton>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm md:text-base text-gray-300 mb-12" data-id="element-114">
            <div className="flex items-center gap-2" data-id="element-115">
              <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-116" /> Acceso
              inmediato y descarga instantánea
            </div>
            <div className="flex items-center gap-2" data-id="element-117">
              <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-118" /> Garantía
              incondicional de 7 días
            </div>
            <div className="flex items-center gap-2" data-id="element-119">
              <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-120" /> Una
              inversión menor que un almuerzo
            </div>
          </div>

          <blockquote className="text-2xl md:text-3xl text-gold font-serif italic max-w-3xl mx-auto" data-id="element-121">
            "Deja de sabotear tu abundancia. Elige hoy tu Plan de 7 Pasos."
          </blockquote>
        </motion.div>
      </div>
    </section>;
}